import styled from 'styled-components';

export const CardStyled = styled.div`
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
`;
